export type RenderProfileId = 'cinematic' | 'balanced' | 'retro';

export interface RenderProfile {
  id: RenderProfileId;
  antialias: boolean;
  maxPixelRatio: number;
  resolutionScale: number;
  softShadows: boolean;
  filmicToneMapping: boolean;
  exposure: number;
  xrFramebufferScale: number;
}

const PROFILES: Record<RenderProfileId, RenderProfile> = {
  cinematic: {
    id: 'cinematic',
    antialias: true,
    maxPixelRatio: 1.5,
    resolutionScale: 1,
    softShadows: true,
    filmicToneMapping: true,
    exposure: 1.12,
    // Standalone headsets render two high-resolution eyes; desktop's
    // cinematic scale misses frame budget even with fixed foveation.
    xrFramebufferScale: 0.72,
  },
  balanced: {
    id: 'balanced',
    antialias: true,
    maxPixelRatio: 1.15,
    resolutionScale: 0.85,
    softShadows: true,
    filmicToneMapping: true,
    exposure: 1.1,
    xrFramebufferScale: 0.7,
  },
  retro: {
    id: 'retro',
    antialias: false,
    maxPixelRatio: 1,
    resolutionScale: 0.4,
    softShadows: false,
    filmicToneMapping: false,
    exposure: 1,
    xrFramebufferScale: 0.68,
  },
};

/**
 * Stable query override for QA and low-spec devices:
 *   ?render=cinematic | balanced | retro
 */
export function selectRenderProfile(): RenderProfile {
  const requested = new URLSearchParams(location.search).get('render') as RenderProfileId | null;
  if (requested && requested in PROFILES) return PROFILES[requested];

  const lowCoreCount = typeof navigator.hardwareConcurrency === 'number' && navigator.hardwareConcurrency <= 4;
  return lowCoreCount ? PROFILES.balanced : PROFILES.cinematic;
}
